import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteWageTypes,
  getDepartments,
  getCategory,
  insertWageType,
  getWageType,
  getCategorys,
  getWageTypes,
  insertWageTypes,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import axios from "axios";
import { getSecureItem } from "../../services/SecureStorage";

export default function WageType() {
  const UID = getSecureItem("userId");
  const [addWageTypeModal, setAddWageTypeModal] = useState(false);
  const [editWageTypeModal, setEditWageTypeModal] = useState(false);
  const [wageTypes, setWageTypes] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [deleteWageTypeId, setDeleteWageTypeId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [wageTypeData, setWageTypeData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    CategoryId: "",
    UserId: UID,
  });

  const openAddWageTypeModal = () => {
    setWageTypeData({
      Id: "",
      Name: "",
      Narration: "",
      CategoryId: "",
      UserId: UID,
    });
    setAddWageTypeModal(!addWageTypeModal);
  };

  const openEditWageTypeModal = (data) => {
    console.log("data", data);
    // profitcenter id name
    const CategoryName = categorys.find((item) => {
      if (item.Id == data?.CategoryId) {
        console.log(categorys, "crProfit");
        console.log(item, "critem");
        return item?.Name;
      }
    });
    console.log("CategoryName", CategoryName);

    setWageTypeData({
      ...data,
      CategoryId: data?.CategoryId,
      // DepartmentId: data.DepartmentId,
      CategoryName: CategoryName?.Name,
      // Department: DepartmentName?.Name,
      UserId: UID || "",
    });
    setEditWageTypeModal(!editWageTypeModal);
  };

  const fetchWageTypes = async () => {
    try {
      const data = await getWageTypes(UID);
      console.log(data.data.data, "Fetched data");
      setWageTypes(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching wageTypes", error);
    }
    setLoading(false);
  };


  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setWageTypeData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const openModal = (WageTypeId) => {
    setDeleteWageTypeId(WageTypeId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteWageTypeId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deleteWageTypeId) {
      handleDelete(deleteWageTypeId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();
    setLoading(true);
    try {
      const response = await insertWageTypes(wageTypeData);
      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchWageTypes();
        openAddWageTypeModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("This Wage already Added");
        setLoading(false);
      } else {
        toast.error("Error occurred while adding Wage Type.");
      }
    } finally {
      setLoading(false);
    }
  };

  // edit
  const handleEdit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setLoading(true);
    try {
      const response = await insertWageTypes(wageTypeData);
      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchWageTypes();
        openEditWageTypeModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code or Name is already in use. Please use a unique code");
      } else {
        toast.error("Error occurred while editing Wage Type.");
      }
      console.error("Error editing Wage Type:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (wageTypeId) => {
    const removeData = { Id: wageTypeId, TableName: "WageType" };
    try {
      const res = await deleteWageTypes(removeData, UID); // Adjust with actual API call
      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Wage Type deleted successfully");
          fetchWageTypes(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Wage Type ");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Wage Type.";
        toast.error('Wage Type already using cannot delete');
      } else {
        console.error("Error removing Wage Type:", error);
        toast.error("Error deleting Wage Type. Please try again.");
      }
    }
  };

  


  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "WageType",
      selector: (row) => row.Name,
      sortable: true,
    },
    // {
    //   name: "Category ",
    //   // selector: (row) => row.CategoryName,
    //   // sortable: true,
    //   selector: (row) => {
    //     const category = categorys?.find((el) => el.Id === row.CategoryId);
    //     console.log("111departmentName", category, "row.CommonDataId", row.CategoryId, );

    //     return category ? category.Name : "N/A"; // Handle case where category is not found
    //   },
    // },
    
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
    },
    // {
    //   name: "Amount ",
    //   selector: (row) => row.Amount||0,
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditWageTypeModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];
  

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

    const filteredItems = dataFilter.filter((item) => {
      const category = categorys?.find((el) => el.Id === item.CategoryId);
      return (
        // item.Id.toLowerCase().includes(filterText.toLowerCase()) || // Uncomment this if filtering by `Id` is required.
        item.Name.toLowerCase().includes(filterText.toLowerCase()) ||
        item.Narration?.toLowerCase().includes(filterText.toLowerCase()) ||
        (item.Code?.toString().toLowerCase().includes(filterText.toLowerCase()))


        // category?.Name.toLowerCase().includes(filterText.toLowerCase()) 
      );
    });
    

  const subHeaderComponentMemo = useMemo(() => {
  }, [filterText, resetPaginationToggle]);

  const clearData = () => {
    setWageTypeData({
      Id: "",
      Name: "",
      Narration: "",
      CategoryId: "",
      Amount: "",
      CategoryName: "Select Category",
      UserId: UID,
    });
  };

  const clearDataForEdit = () => {
    setWageTypeData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      CategoryId: "",
      Amount: "",
      CategoryName: "Select Category",
      UserId: UID,
    }));
  };

  useEffect(() => {
    const fetchCategorys = async () => {
      try {
        const response = await getCategorys(UID);
        // const responses = await getDepartments(UID);

        // setDepartment(responses.data.data);
        // console.log(department,"dept");

        setCategorys(response.data.data);
        console.log(categorys, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchCategorys();
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchWageTypes();
  }, []);

  useEffect(() => {
    if (wageTypes && wageTypes.length > 0) {
      const updatedData = wageTypes.map((item, index) => {
        // Find the category name that matches the CategoryId
        const category = categorys.find(
          (category) => category.Id === item.CategoryId
        );
        return {
          Slno: index + 1,
          Id: item.Id || "",
          Name: item.Name || "",
          Narration: item.Narration || "",
          Code: item.Code || "",
          CategoryId: item.CategoryId || "",
          CategoryName: category ? category.Name : "", // Set CategoryName if category is found
          Amount: item.Amount || "",
          UserId: UID || "",
          // DepartmentId: item.DepartmentId || "",
        };
      });
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [wageTypes]); // Added categories as a dependency


  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Wage Type?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
       <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Wage Type"  />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by WageType/Code"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddWageTypeModal}
            // disabled
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={wageTypes} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

      <div className="react-data-table">
        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <ReactDataTable
              columns={columnsFilter}
              data={filteredItems}
              pagination
              paginationResetDefaultPage={resetPaginationToggle}
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
            />
          )}
        </div>
      </div>
      </div>

      {/* =========================================================Add=============================================== */}

      {addWageTypeModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Wage Type
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openAddWageTypeModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[85vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                      WageType <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={wageTypeData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={wageTypeData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Code <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="code"
                        name="Code"
                        placeholder="Code"
                        value={wageTypeData.Code}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Category <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="CategoryId"
                        value={wageTypeData.CategoryId}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select Category
                        </option>
                        {categorys.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Amount <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="amount"
                        name="Amount"
                        placeholder="Amount"
                        value={wageTypeData.Amount}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}
                      />
                    </div> */}
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openAddWageTypeModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* =========================================================Edit=============================================== */}

      {editWageTypeModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit Wage Type
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openEditWageTypeModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[85vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                      WageType<span className="text-red-500"> *</span>
                      </label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={wageTypeData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={wageTypeData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Code<span className="text-red-500"> *</span>
                      </label>
                      <input
                        type="text"
                        id="Code"
                        name="Code"
                        placeholder="Code"
                        value={wageTypeData.Code}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Category<span className="text-red-500"> *</span>
                      </label>
                      <select 
                        name="CategoryId"
                        value={wageTypeData.CategoryId}
                        onChange={handleChange}
                        required
                      >
                        <option key="" value="">
                          Select Category
                        </option>
                        {categorys.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Amount<span className="text-red-500"> *</span>
                      </label>
                      <input
                        type="number"
                        id="Amount"
                        name="Amount"
                        placeholder="Amount"
                        value={wageTypeData.Amount ||0}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}
                      />
                    </div> */}
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openEditWageTypeModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
